"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.duration = exports.soundIcon = exports.videoName = exports.videoInfo = void 0;

var _util = require("../../../../../util");

const videoInfo = ({
  theme
}) => ({
  background: (0, _util.color)(theme, 'overlay1'),
  width: '100%'
});

exports.videoInfo = videoInfo;

const videoName = ({
  theme
}) => ({
  color: (0, _util.color)(theme, 'text.3'),
  fontSize: '16px'
});

exports.videoName = videoName;

const soundIcon = ({
  theme
}) => ({
  color: (0, _util.color)(theme, 'text.3'),
  cursor: 'pointer'
});

exports.soundIcon = soundIcon;

const duration = ({
  theme
}) => ({
  color: (0, _util.color)(theme, 'text.3')
});

exports.duration = duration;
//# sourceMappingURL=VideoInfo.style.js.map